export default __webpack_public_path__ + "static/play-button-1fa237bc630c3505fbe113b1d2d82b95.png";